import React, { useContext, useEffect } from 'react';
import logo from './logo.png';
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faComputer, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import TranscribeInput from './components/input/Input';
import Button from './components/button/Button';
import Markdown from 'react-markdown'
import { API_BASE_URL } from './constants';
import { AuthContext } from './auth';

// import TEST_JSON from './test';

type Practice = Record<string, any>;

type Message = {
  sender: string;
  text: string;
  unFinalized?: string,
  practice?: Practice,
}

type Language = "English" | "Tamil";

const SEND_URL = `${API_BASE_URL}/vet/chat`

type AppState = "LOGIN" | "READY" | "SENDING";

// const TEST_MESSAGES: Message[] = [
//   {
//     sender: "user",
//     text: "cow mastitis explain in detail",
//   },
//   {
//     sender: "assistant",
//     text: TEST_JSON.assistant_response_text,
//     practice: TEST_JSON.practice,
//   }
// ]


function App() {
  const [appState, setAppState] = React.useState<AppState>("LOGIN");
  const [email, setEmail] = React.useState<string | undefined>(undefined);
  const [language, setLanguage] = React.useState<Language>("Tamil");
  const [practice, setPractice] = React.useState<Practice | undefined>(undefined);

  // use auth context
  const authContext = useContext(AuthContext);

  const [messages, setMessages] = React.useState<Message[]>([
    // ...TEST_MESSAGES,
    // {
    //   sender: "user",
    //   text: "ஹலோ எப்படி இருக்கீங்க?",
    // },
    // {
    //   sender: "assistant",
    //   text: "ஆம் நான் நன்றாக இருக்கிறேன். ஆம் நான் நன்றாக இருக்கிறேன். ஆம் நான் நன்றாக இருக்கிறேன்.",
    // },
    {
      sender: "user",
      text: "",
    }
  ]);

  useEffect(() => {
    if (appState === "SENDING") {
      sendReceiveChat()
        .catch((e) => {
          console.error("Error sending chat: ", e);
        });
    }
  }, [appState]);

  const checkLogin = async () => {
    if (!authContext || !authContext.token) {
      throw new Error("no auth token");
    }
    const res = await fetch(`${API_BASE_URL}/auth/info`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": authContext.token,
      },
    });
    if (!res.ok) {
      throw new Error("no auth info");
    }
    const json = await res.json();
    console.log(json);
    return json["sub"];
  }

  useEffect(() => {
    if (appState === "LOGIN") {
      checkLogin()
        .then((email) => {
          console.log("Email: ", email);
          setEmail(email);
          setAppState("READY");
        })
        .catch((e) => {
          console.error("Error checking login: ", e);
        });
    }
  }, [appState, authContext]);

  const messageCallBack = (message: string, is_final: boolean) => {

    // if last message is user, use it, otherwise, create new message
    let newLastMessage;
    if (messages.length > 0 && messages[messages.length - 1].sender === "user") {
      newLastMessage = messages[messages.length - 1];
    } else {
      newLastMessage = {
        sender: "user",
        text: "",
      }
    }

    if (is_final) {
      newLastMessage.text += " " + message;
      newLastMessage.unFinalized = undefined;
    } else {
      newLastMessage.unFinalized = message;
    }

    setMessages(
      [
        ...messages.slice(0, messages.length - 1),
        newLastMessage,
      ]
    )
  }

  const textChanged = (idx: number, ev: React.ChangeEvent<HTMLInputElement>) => {
    const newMsg = ev.target.value;
    setMessages(messages.map((m, jdx) => {
      if (idx == jdx) {
        m.text = ev.target.value;
      }
      return m;
    }));
  }

  const toggleLanguage = () => {
    if (language === "English") {
      setLanguage("Tamil");
    } else {
      setLanguage("English");
    }
  }

  const onSendClick = async (ev: any) => {
    if (appState === "READY") {
      setAppState("SENDING");
    }
  }

  const sendReceiveChat = async () => {
    try {
      if (!authContext || !authContext.token) {
        throw new Error("no auth token");
      }
      const response = await fetch(SEND_URL, {
        method: "POST",
        body: JSON.stringify({
          messages: messages.map(m => ({
            content: m.text,
            role: m.sender,
          }))
        }),
        headers: {
          "Content-Type": "application/json",
          "X-Access-Token": authContext.token,
        }
      });

      // parse response json
      const responseJson = await response.json();
      if (!response.ok) {
        throw new Error(responseJson);
      }

      const responseText = responseJson.assistant_response_text || "[No Message!]";
      const practice = responseJson.practice;
      setMessages([
        ...messages,
        {
          sender: "assistant",
          text: responseText,
          practice: practice,
        },
        {
          sender: "user",
          text: "",
        }
      ]);
      console.info(
        responseJson
      );
      setAppState("READY");
    } catch (e) {
      console.error("Error posting chat message: ", e);
    }

  };

  return (
    <div className="App" >
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <div className="App-title">
          <h1>
            SEVA Vet Bot
          </h1>
          <h3 className="Login">
            {
              email ?
                `${email}` :
                <a href={`${API_BASE_URL}/auth/google`}>Login</a>
            }
          </h3>
        </div>
      </header>
      <div className="App-body">

        <div className="Chats">
          {
            messages.map((msg, idx) => {
              if ((msg.sender === "user") && (idx === messages.length - 1)) {
                return (
                  <div key={idx} className={"ChatBubble " + (msg.sender === "user" ? "UserChat" : "BotChat")}>
                    <input
                      onChange={(ev) => textChanged(idx, ev)} type="text" value={msg.text} aria-multiline={true} height={2}
                      disabled={appState !== "READY"}
                    />
                  </div>
                )
              }
              if (msg.sender === "user") {
                return (
                  <div key={idx} className={"ChatBubble UserChat"}>
                    <FontAwesomeIcon icon={faUser} className="Icon" />
                    <div className="Text">
                      <p>
                        {msg.text}
                      </p>
                    </div>
                  </div>
                )
              }
              return (
                <div key={idx} className={"ChatBubble BotChat"}>
                  <FontAwesomeIcon icon={faComputer} className="Icon" />
                  <div className="Text">
                    {msg.practice?.toc &&
                      <button
                        className="PracticeLink"
                        onClick={() => setPractice(msg.practice)}
                      >
                        {"Practice: " + msg.practice.toc}


                      </button>}
                    <Markdown>{msg.text}</Markdown>
                  </div>
                </div>
              );
            })
          }

        </div>

        <div className="Inputs">
          <label className="Switch">
            <input type="checkbox" checked={language == "English"} onChange={(ev) => toggleLanguage()} />
            <span className="slider round"></span>
            <p>{language}</p>
          </label>
          <TranscribeInput
            transcriptCallBack={(msg, is_final) => messageCallBack(msg, is_final)}
            language={language} />
          <Button
            onClick={(ev: any) => onSendClick(ev)}
            disabled={appState !== "READY"}
          >
            <FontAwesomeIcon icon={faPaperPlane} className="Icon" />
            <p>Send</p>
          </Button>
        </div>


        {practice && <div className="Practice">
          <button className="GoBack" onClick={(ev) => setPractice(undefined)}>Go Back</button>
          <Markdown>
            {practice.section_text}
          </Markdown>
        </div>
        }
      </div>
    </div>
  );
}

export default App;
